import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { serverEndPoint } from '../../actions/Utils';

import { Container, IconButton, Typography } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import TableHeader from '../common/TableHeader';
import { ModalAction } from '../common/Modal';
import { Title } from './style';
import { Noresults } from '../../Layout/style';
import { Text } from '../common/NotificationTable/style';
import { createSecureText, deleteSecureTextById, getSecureTexts, getSecureTextById, updateSecureText } from '../../actions/SecureText';
import AddSecureText from '../Forms/AddSecureText';

const AdminSecureText = () => {
    const dispatch = useDispatch();
    const {user } = useSelector(({  auth }) => ({
      user: auth?.userData?.userLogado?.adm_login || null
    })); 

    const [modal, setModal] = useState({
        open: false,
        type: null,
        title: null,
        action: null,
    });

    const [formData, setFormData] = useState({});
    const [searchString, setSearchString] = useState('');
    const [secureTexts, setSecureTexts] = useState([]);
    const [secureTextsLista, setSecureTextsLista] = useState([]);
    let valideFormData = formData?.text_box && formData?.description;


    useEffect(() => {
        handleMensagem()
    }, []); 

    const handleMensagem = async () =>{
      let resp = await axios.get(`${serverEndPoint}/secure/getSecureTexts`);
      setSecureTexts(resp.data)
      setSecureTextsLista(resp.data)
    }
  
    useEffect(() => {
        if (searchString?.length > 0) {
          setSecureTextsLista(
            secureTexts.filter((i) => {
            return i.text_box.toUpperCase().match(searchString.toUpperCase());
            }),
        );
        } else setSecureTextsLista(secureTexts);
    }, [secureTexts, searchString]);

  const closeAndUpdate = useCallback(() => {
    handleMensagem()
    setFormData({});
    setModal({ open: false, type: null, title: null, action: null });
  });


  const handleAdd = useCallback(async () => {
    formData.userWhoCreated = user
    try{
      let respCreate = await axios.post(`${serverEndPoint}/secure/createSecureText`,formData);
      if(respCreate.status === 200){
        closeAndUpdate()
      }
    }catch(e){
      console.log(e)
      alert('Erro ao incluir Texto')
    }
  });

  const handleDelete = useCallback(async (id) => {
    try{
      let respDelete = await axios.delete(`${serverEndPoint}/secure/deleteSecureTextById/${id}`);
      if(respDelete.status === 200){
        closeAndUpdate()
      }
    }catch(e){
      console.log(e)
      alert('Erro ao excluir o Texto')
    }
  });

  const handleEdit = useCallback(async (id) => {
    try{
      let respTexto = await axios.get(`${serverEndPoint}/secure/getSecureTextById/${id}`);
      if(respTexto.status === 200){
        let dados = {id:id, text_box: respTexto.data[0].text_box, description: respTexto.data[0].description}
        setFormData(dados)
        setModal({
          open: true,
          type: 'edit',
          title: 'Editar Texto de Segurança',
        })
      }
    }catch(e){
      console.log(e)
      alert('Erro ao carregar o Texto')
    }   
  }); 

  const handleUpdate = useCallback(async () => {
    try{
      formData.userWhoModified = user
      let respTexto = await axios.put(`${serverEndPoint}/secure/updateSecureText`,formData);
      if(respTexto.status === 200){
        closeAndUpdate()
      }
    }catch(e){
      console.log(e)
      alert('Erro ao atualizar o Texto')
    }
  }); 

  const handleStatus = useCallback(async (status,id) => {
    try{
      let dados = {userWhoModified:user,active:status,id:id}
      
      //formData.userWhoModified = user
      let respTexto = await axios.put(`${serverEndPoint}/secure/updateSecureText`,dados);
      if(respTexto.status === 200){
        closeAndUpdate()
      }
    }catch(e){
      console.log(e)
      alert('Erro ao atualizar o Texto')
    }
  }); 
  
  

  const columns = [ 
    {
        field : 'text_box', 
        flex: 4, 
        headerName: 'Texto', 
        renderCell: ({ row }) => <Text>{row.text_box}</Text>,
    }, 
    { 
        field: 'description',
        flex: 2, 
        headerName: 'Descrição', 
        renderCell: ({ row }) => <Text>{row.description}</Text>,
    }, 
    {
       field: 'active', 
       flex: 1, 
       headerName: 'Status', 
       renderCell: ({row}) => {
         return row.active === 1 ? <div style={{cursor:"pointer", backgroundColor:"#ff450a",color:"whitesmoke",padding:"5px",height:"30px",display:"flex",alignItems:"center"}} onClick={()=>{handleStatus(0,row.id)}}>Ativado</div> : 
         <div style={{cursor:"pointer", backgroundColor:"#ff450a",color:"whitesmoke",padding:"5px",height:"30px",display:"flex",alignItems:"center"}} onClick={()=>{handleStatus(1,row.id)}}>Desativado</div>
       }
    },
    { 
        field: 'actions', 
        headerName: 'Ações',
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => (
            <>
                <IconButton  onClick={() => {
                   handleEdit(row.id)
                }}> 
                 <FontAwesomeIcon icon={faEdit} />
                </IconButton>

                <IconButton onClick={() => 
                    setModal({
                        open: true,
                        type: 'del',
                        title: 'Deletar Texto de Segurança',
                        action: () => {
                            handleDelete(row.id)
                        }
                    })
                }>
                 <FontAwesomeIcon icon={faTrashAlt} />    
                </IconButton>
            </>
        ),    
    }, 
  ];


 return ( 
    <>
     <Container> 
        <Title variant='h2'>Gestão de Textos de Segurança</Title>
        <TableHeader
          setSearchString={setSearchString}
          placeholder="Pesquisar por texto"
          btnAction={() =>
            setModal({
              open: true,
              type: 'add',
              title: 'Adicionar Texto de Segurança',
              action: () => handleAdd(),
            })
          }
        /> 
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
           components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            loading={secureTextsLista ? false : true}
            rows={secureTextsLista.length ? secureTextsLista : []}
            columns={columns}
          />
        </div>    
     </Container>
     <ModalAction
        title={modal.title || 'Modal'} 
        successAction={modal.type === 'add' ? () => handleAdd() : modal.type === 'edit' ? () => handleUpdate() : modal.action}
        successLabel={modal.type === 'add' || modal.type === 'edit' ? 'Salvar' : 'Deletar'}
        open={modal.open}
        successActive={modal.type === 'add' || modal.type === 'edit' ? (valideFormData ? true : false) : true}
        backAction={() => {
          setModal({ open: false, type: null });
          setFormData({});
        }} 
     >
        {modal.type === 'add' && <AddSecureText formData={formData} setFormData={setFormData} />}
        {modal.type === 'edit' && <AddSecureText formData={formData} setFormData={setFormData} />}
        {modal.type === 'del' && <Typography>Tem certeza que deseja deletar o Texto de Segurança?</Typography>}
     </ModalAction>
    </>
 );

};

export default AdminSecureText;